import request from "@/utils/request";

export const getXlsxFile = (ids) => {
  return request.get("v1/cap/imsbs/download?ids=" + ids);
};
